import {
  getWaitingArea,
  getWaitingAreas,
  waitingareasNeedToUpdate,
  removeWAFromReduer,
  getConsultNowInitiatedCalls,
} from 'actions/waitingArea';
import { queueESEvents, ESEventTypes } from './logEventToElasticSearch';

function parseIDFromURL(url, matchStr) {
  let parseURLArray = url.split(matchStr);
  return parseURLArray[parseURLArray.length - 1];
}

export function getWaitingAreasDetails(dispatcher, cb) {
  // Need to check if it's on PIWA page
  let viewingWAId = null;
  var locationOfPage = window.location.href.split('?')[0] || window.location.href;
  if (locationOfPage.indexOf('waiting-area/view-one') > -1) {
    viewingWAId = parseIDFromURL(locationOfPage, 'waiting-area/view-one/');
  } else if (locationOfPage.indexOf('waiting-area/manage-users') > -1) {
    viewingWAId = parseIDFromURL(locationOfPage, 'waiting-area/manage-users/');
  } else if (locationOfPage.indexOf('waiting-area/manage-tags') > -1) {
    viewingWAId = parseIDFromURL(locationOfPage, 'waiting-area/manage-tags/');
  }
  // if on piwa / manageUsers / manageTags WA page
  if (!!viewingWAId) {
    let errCB = (err, id) => {
      if (err && err.status == 404) {
        dispatcher(removeWAFromReduer(viewingWAId));
      }
    };
    queueESEvents(
      ESEventTypes.APICall,
      `In getWaitingAreasDetails(due to pubnub): ${viewingWAId}`,
      'eventType&apiURL',
      {
        apiURL: window.APP.CONFIGURATION.VCCAPI + 'waitingareas/' + viewingWAId + '/calls',
        browserURL: window.location.href,
      },
      null,
      true,
      'info'
    );

    let getWaitingAreaCB = (data) => {
      // Check if consult now is enabled. If it's enabled, it needs to fetch initiated calls as well
      if (locationOfPage.indexOf('waiting-area/view-one') > -1) {
        if (data.isConsultNowEnabled === true) {
          dispatcher(getConsultNowInitiatedCalls(viewingWAId));
        }
      }
    };
    dispatcher(getWaitingArea(viewingWAId, getWaitingAreaCB, errCB));
    // reset waitingAreasNeedToUpdate flag
    dispatcher(waitingareasNeedToUpdate(false));
    if (cb) cb();
  } else if (locationOfPage.indexOf('waiting-area/view-all') > -1) {
    // If on WA listing page
    dispatcher(getWaitingAreas());
    if (cb) cb();
  } else {
    // If on any other page, reset the flag
    // reset waitingAreasNeedToUpdate flag
    dispatcher(waitingareasNeedToUpdate(false));
    if (cb) cb();
  }
}
